const systemState = {
  languageSetting: [],
  systemSetting: []
}

export default systemState